module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-wrap",
    attrs: {
      "id": "wrap"
    }
  }, [_c('component-header', {
    attrs: {
      "headerdata": _vm.set_headers
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "pager"
  }, [_c('div', {
    staticClass: "container card-box",
    staticStyle: {
      "height": "100vh",
      "padding": "1em 2em"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [(!_vm.know_terms) ? _c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.card_view.card1) ? _c('div', {
    staticClass: "card-view",
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "id": "login"
    }
  }, [_c('p', {
    staticStyle: {
      "color": "#ff3c00"
    }
  }, [_vm._v("Create your account")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 col-xs-offset-5",
    staticStyle: {
      "text-align": "center"
    }
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e()]), _vm._v(" "), _c('form', {
    key: _vm.formComponentKey,
    staticClass: "form-inline"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group wnf-fl-form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Name")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.name),
      expression: "user.name"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "type": "text",
      "title": "Enter  name",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.user.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.name = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group wnf-fl-form-group col-xs-12"
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.email),
      expression: "user.email"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "id": "email",
      "type": "text",
      "title": "Enter Email",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.user.email)
    },
    on: {
      "change": function($event) {
        _vm.validateEmail(_vm.user.email)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.email = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-top": "-2.3em",
      "float": "right"
    }
  }, [(_vm.action_checking.email) ? _c('i', {}, [_c('div', {
    staticClass: "loading-xxs"
  })]) : _vm._e(), _vm._v(" "), ((_vm.user.email && _vm.action_verified.email) && (!_vm.error_messages.email)) ? _c('i', {
    staticClass: "fa fa-check"
  }) : _vm._e(), _vm._v(" "), (_vm.error_messages.email) ? _c('i', {
    staticClass: "fa fa-times",
    staticStyle: {
      "color": "#ff0000"
    }
  }) : _vm._e()])])]), _vm._v(" "), (_vm.error_messages.email) ? _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.error_messages.email))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group wnf-fl-form-group col-xs-12"
  }, [_c('label', {
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Phone Number")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.phone),
      expression: "user.phone"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "id": "phone",
      "type": "number",
      "name": "Phone",
      "title": "Enter Phone Number",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.user.phone)
    },
    on: {
      "change": function($event) {
        _vm.validatePhone(_vm.user.phone)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.phone = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-top": "-2.3em",
      "float": "right"
    }
  }, [(_vm.action_checking.phone) ? _c('i', {}, [_c('div', {
    staticClass: "loading-xxs"
  })]) : _vm._e(), _vm._v(" "), ((_vm.user.phone && _vm.action_verified.phone) && (!_vm.error_messages.phone)) ? _c('i', {
    staticClass: " fa fa-check"
  }) : _vm._e(), _vm._v(" "), (_vm.error_messages.phone) ? _c('i', {
    staticClass: " fa fa-times",
    staticStyle: {
      "color": "#ff0000"
    }
  }) : _vm._e()])])]), _vm._v(" "), (_vm.error_messages.phone) ? _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.error_messages.phone))]) : _vm._e(), _vm._v(" "), (_vm.ref_code == '') ? _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group wnf-fl-form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Referral Code")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ref_code),
      expression: "ref_code"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "type": "text",
      "size": "4",
      "title": "Enter Ref Code",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.ref_code)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ref_code = $event.target.value
      }
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.terms),
      expression: "terms"
    }],
    attrs: {
      "type": "checkbox",
      "id": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.terms) ? _vm._i(_vm.terms, null) > -1 : (_vm.terms)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.terms,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.terms = $$a.concat($$v))
          } else {
            $$i > -1 && (_vm.terms = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.terms = $$c
        }
      }
    }
  }), _vm._v(" I agree to "), _c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#ff3c00"
    },
    on: {
      "click": function($event) {
        _vm.showTerms(true)
      }
    }
  }, [_vm._v("Terms and Conditions")]), _vm._v(" "), (!_vm.terms) ? _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.error_messages.terms))]) : _vm._e()])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#0400ff",
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default wnf-button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reg_step_01
    }
  }, [_vm._v("Next")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "12px"
    }
  }, [_vm._v("Next >> secure your account")])]) : _vm._e(), _vm._v(" "), (_vm.card_view.card2) ? _c('div', {
    staticClass: "card-view",
    staticStyle: {
      "text-align": "left"
    },
    attrs: {
      "id": "login"
    }
  }, [_c('a', {
    staticStyle: {
      "float": "right",
      "cursor": "pointer",
      "margin-bottom": "10px",
      "color": "#000000"
    },
    on: {
      "click": function($event) {
        _vm.setCardGuide('card1')
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-angle-left"
  }), _vm._v(" Back")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-4 col-xs-offset-5",
    staticStyle: {
      "text-align": "center"
    }
  }, [(_vm.action_loading) ? _c('div', {
    staticClass: "loading-sm"
  }) : _vm._e()]), _vm._v(" "), _c('form', {
    key: _vm.form2ComponentKey,
    staticClass: "form-inline"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group wnf-fl-form-group col-xs-12"
  }, [_c('label', {}, [_vm._v("Username")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.username),
      expression: "user.username"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "id": "firstname",
      "type": "text",
      "name": "username",
      "title": "Enter  name",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.user.username)
    },
    on: {
      "change": function($event) {
        _vm.validateUsername(_vm.user.username)
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.username = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-top": "-2.3em",
      "float": "right"
    }
  }, [(_vm.action_checking.username) ? _c('i', {}, [_c('div', {
    staticClass: "loading-xxs"
  })]) : _vm._e(), _vm._v(" "), ((_vm.user.username && _vm.action_verified.username) && (!_vm.error_messages.username)) ? _c('i', {
    staticClass: " fa fa-check"
  }) : _vm._e(), _vm._v(" "), (_vm.error_messages.username) ? _c('i', {
    staticClass: " fa fa-times",
    staticStyle: {
      "color": "#ff0000"
    }
  }) : _vm._e()])]), _vm._v(" "), (_vm.error_messages.username) ? _c('p', {
    staticStyle: {
      "color": "#ff0000",
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.error_messages.username))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "form-group wnf-fl-form-group col-xs-12"
  }, [_c('label', {
    attrs: {
      "for": "password"
    }
  }, [_vm._v("Password")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.user.password),
      expression: "user.password"
    }],
    staticClass: "form-control input-bflat",
    attrs: {
      "id": "password",
      "type": "password",
      "title": "Enter password",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.user.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.user.password = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#0400ff",
      "font-size": "12px"
    }
  }, [_vm._v(_vm._s(_vm.data_processing_message))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-default wnf-button",
    attrs: {
      "disabled": _vm.disable_btn
    },
    on: {
      "click": _vm.reg_step_02
    }
  }, [_vm._v("Continue")])]) : _vm._e(), _vm._v(" "), (!_vm.card_view.card3) ? _c('div', {}, [_c('br'), _c('br'), _vm._v(" "), _vm._m(1)]) : _vm._e(), _vm._v(" "), (_vm.card_view.card3) ? _c('div', {
    staticClass: "card-view",
    staticStyle: {
      "text-align": "center",
      "margin-top": "-4em"
    }
  }, [_vm._m(2), _vm._v(" "), (_vm.group_name != '') ? _c('p', {
    staticClass: "text-muted"
  }, [_c('b', [_vm._v(".. " + _vm._s(_vm.group_name) + " ..")])]) : _c('p', {
    staticClass: "text-muted"
  }, [_vm._v("next")]), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "card-onboarding"
  }, [_c('div', {
    staticClass: "row card card-row",
    staticStyle: {
      "display": "none",
      "padding": "0",
      "box-shadow": "0 0 15px 4px rgba(0,0,0,0.06)"
    }
  }, [_c('div', {}, [_c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "/buypoint"
    }
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col-xs-9",
    staticStyle: {
      "background-color": "#ffd4cc",
      "padding": "1.2em 0.1em",
      "text-align": "left"
    }
  }, [(_vm.group_is_set) ? _c('p', {
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Start Shopping "), _c('br'), _vm._v("Check out Stores in tribe")]) : _c('p', {
    staticStyle: {
      "margin-left": "1em"
    }
  }, [_vm._v("Start Shopping Grow your list "), _c('br'), _vm._v("Check out Stores and Tribes")])])])]), _c('br')]), _vm._v(" "), _vm._m(4)])]) : _vm._e()]) : _c('div', {
    staticClass: "col-xs-12"
  }, [_c('button', {
    staticClass: "btn btn-default",
    staticStyle: {
      "float": "right",
      "font-size": "24px",
      "color": "#000000"
    },
    on: {
      "click": function($event) {
        _vm.showTerms(false)
      }
    }
  }, [_vm._v("X")]), _vm._v(" "), _c('h3', [_vm._v("Terms and condition")])])])])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "clear": "both",
      "color": "#ff3c00",
      "font-weight": "bold"
    }
  }, [_vm._v("Secure your account with a "), _c('br'), _vm._v(" Username and Password")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#ff3c00",
      "font-weight": "bolder"
    },
    attrs: {
      "href": "/login"
    }
  }, [_vm._v("Have you set up an account? - Login here")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('a', {
    staticStyle: {
      "display": "none",
      "cursor": "pointer",
      "color": "#ff3c00",
      "font-weight": "bolder"
    },
    attrs: {
      "href": "/login"
    }
  }, [_vm._v("Your account have been created, pick any option below to get started")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-3",
    staticStyle: {
      "text-align": "center",
      "padding": "1.2em 5px",
      "background-color": "#ffffff"
    }
  }, [_c('i', {
    staticClass: "wn-icon-lgflt fa fa-users",
    staticStyle: {
      "font-size": "42px",
      "color": "#ee4917"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row card card-row",
    staticStyle: {
      "padding": "0",
      "box-shadow": "0 0 15px 4px rgba(0,0,0,0.06)"
    }
  }, [_c('div', {}, [_c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "color": "#000000",
      "border": "#dbdbdb 1px solid",
      "padding": "1.2em 1.1em",
      "text-align": "left",
      "font-size": "18px",
      "line-height": "1.8"
    }
  }, [_c('div', {
    staticStyle: {
      "text-align": "center",
      "padding": "1.2em 5px",
      "background-color": "#ffffff"
    }
  }, [_c('i', {
    staticClass: "wn-icon-lgflt fas fa-store-alt",
    staticStyle: {
      "font-size": "42px",
      "color": "#ee4917"
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("You have successfully created your account. ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('b', [_vm._v("Next_")])]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "padding": "0.5em 1em",
      "margin-bottom": "1em",
      "border-radius": "3px",
      "border": "#e4e4e4 solid 1px"
    }
  }, [_c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "/"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Check out Trending posts, products and services.")]), _vm._v(" "), _c('p', {
    staticClass: "sp-app-default-color-cta",
    staticStyle: {
      "text-align": "center",
      "margin-top": "-0.8em",
      "margin-bottom": "-0.4em"
    }
  }, [_vm._v(" >> ")])])]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "padding": "0.5em 1em",
      "margin-bottom": "1em",
      "border-radius": "3px",
      "border": "#e4e4e4 solid 1px"
    }
  }, [_c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "/account/business/newbusiness"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Create your own shop to sell your products and services.")]), _vm._v(" "), _c('p', {
    staticClass: "sp-app-default-color-cta",
    staticStyle: {
      "text-align": "center",
      "margin-top": "-0.8em",
      "margin-bottom": "-0.4em"
    }
  }, [_vm._v(" >> ")])])]), _vm._v(" "), _c('div', {
    staticClass: "card",
    staticStyle: {
      "padding": "0.5em 1em",
      "margin-bottom": "1em",
      "border-radius": "3px",
      "border": "#e4e4e4 solid 1px"
    }
  }, [_c('a', {
    staticClass: "card-link",
    attrs: {
      "href": "/myshops"
    }
  }, [_c('p', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_vm._v("Search for shops you may know.")]), _vm._v(" "), _c('p', {
    staticClass: "sp-app-default-color-cta",
    staticStyle: {
      "text-align": "center",
      "margin-top": "-0.8em",
      "margin-bottom": "-0.4em"
    }
  }, [_vm._v(" >> ")])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b3d55db4"}!./src/pages/Register/template.html
// module id = 574
// module chunks = 0